var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.833,
    height: 34.543,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 425",
    fill: "#060404"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 374",
    d: "M18.697 26.784l6.88-11.917.607.35-6.88 11.917z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 375",
    d: "M23.412 26.784l5.656-9.796.606.35-5.656 9.796z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 371"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 503",
    d: "M39.325 13.781a9.186 9.186 0 11-3.362-12.548 9.186 9.186 0 013.362 12.548"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 504",
    d: "M40.833 34.543H0V28.71a2.333 2.333 0 012.333-2.333H38.5a2.333 2.333 0 012.333 2.333z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeverIcon);
export default __webpack_public_path__ + "static/media/leverIcon.2dd1d67c0ce0029c.svg";
export { ForwardRef as ReactComponent };